import React from "react"
import { graphql } from "gatsby"
////import Image from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import styles from "./book.module.scss"

const BookTemplate = ({ data }) => {
  const book = data.booksJson

  const dateOptions = {
    hour12: "false",
    day: "2-digit",
    month: "long",
    year: "numeric"
  }
  let date = new Date(book.datePublication)
  date = date.toLocaleDateString("fr-FR", dateOptions)

  return (
    <Layout>
      <SEO
        title={book.title}
        description={book.resume.slice(100)}
      />

      <article>
        <img className="max-w-1/2 float-left mr-4 mb-2" src={book.image.childImageSharp.fixed.src} alt={book.title}/>
        <div>
          <h2>{book.title}</h2>
          <p><span className="font-bold">Date de publication :</span> {date}</p>
          <p className="mb-4"><span className="font-bold">Auteur :</span> {book.auteur}</p>
          <h3 className="font-bold text-xl underline">Résumé</h3>
          <div className={`${styles.format}`} dangerouslySetInnerHTML={{ __html: book.resume }} ></div>
        </div>
      </article>
    </Layout>
  )
}

export default BookTemplate

export const pageQuery = graphql`
  query BookBySlug($slug: String!) {
    booksJson(slug: { eq: $slug }) {
      title
      datePublication
      image {
        childImageSharp {
          fixed(
            width: 607,
            cropFocus: CENTER,
            fit: CONTAIN
          ) {
            height
            width
            src
            srcSet
            tracedSVG
            aspectRatio
          }
        }
      }
      auteur
      resume
    }
  }
`
